import { Theme } from '@mui/material';
import styled from '@mui/system/styled';

export const Wrapper = styled('div')(({ theme }: { theme?: Theme }) => ({
  background: theme.palette.primary.light,
  padding: '50px 0',
  margin: '50px 0'
}));

export const ImgWrapper = styled('div')(({ theme }: { theme?: Theme }) => ({
  borderRadius: '50%',
  overflow: 'hidden',
  '& img': {
    borderRadius: '50%',
    maxWidth: 'fit-content',
    width: '100%',
    height: 'auto',
    padding: '2.5px'
  },
  [theme.breakpoints.up('sm')]: {
    marginRight: '14px',
    marginLeft: '2px',
    '& img': {
      padding: 0
    }
  }
}));

export const QuoteSection = styled('div')(({ theme }: { theme?: Theme }) => ({
  borderLeft: '1px solid #09b3b0',
  paddingLeft: '10px',
  height: '100%',
  paddingTop: 0,
  fontWeight: 400,
  fontSize: '16px',
  [theme.breakpoints.up('sm')]: {
    paddingLeft: '20px'
  }
}));

export const QuoteAuthor = styled('span')(({ theme }: { theme?: Theme }) => ({
  display: 'block',
  marginTop: '15px',
  fontWeight: 500,
  [theme.breakpoints.up('sm')]: {
    marginTop: '30px'
  }
}));

export const TestimonialsWrapper = styled('div')(
  ({ theme }: { theme?: Theme }) => ({
    background: theme.palette.primary.light,
    padding: '30px 0',
    margin: '30px 0',
    '& .testimonials-data-container': {
      padding: '0 5px',
      '.testimonial-item-container': {
        '&.not-last': {
          marginBottom: '15px'
        }
      }
    },
    [theme.breakpoints.up('sm')]: {
      margin: '50px 0',
      padding: '50px 15px 60px',
      '& .testimonials-data-container': {
        maxWidth: '738px',
        padding: 0,
        '.testimonial-item-container': {
          padding: '0 5px',
          '&.not-last': {
            marginBottom: 0
          }
        }
      }
    },
    [theme.breakpoints.up('md')]: {
      '& .testimonials-data-container': {
        maxWidth: '962px'
      }
    },
    [theme.breakpoints.up('lg')]: {
      '& .testimonials-data-container': {
        maxWidth: '1100px'
      }
    }
  })
);
